// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__38mKO","header":"MessagesList_header__DZ7jD","chat":"MessagesList_chat__2JUOU"};